import { Temporal } from "temporal-polyfill";

type Timestamp = string | Date;

function toInstant(value: Timestamp) {
  return Temporal.Instant.from(
    value instanceof Date ? value.toISOString() : value,
  );
}

/** "Sep 28, 2026" for a saved timestamp; "—" when it is missing or invalid. */
export function formatRunDate(value: Timestamp | null | undefined): string {
  if (!value) {
    return "—";
  }
  try {
    return toInstant(value).toLocaleString("en-US", { dateStyle: "medium" });
  } catch {
    return "—";
  }
}

/** "3:55 PM" for a saved timestamp; an empty string when it is missing. */
export function formatRunTime(value: Timestamp | null | undefined): string {
  if (!value) {
    return "";
  }
  try {
    return toInstant(value).toLocaleString("en-US", { timeStyle: "short" });
  } catch {
    return "";
  }
}
